module.exports = __webpack_public_path__ + "kw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kw.svg
// module id = 648
// module chunks = 0